'use client';
import Image from 'next/image';
import Link from 'next/link';
import { Bounce, toast } from 'react-toastify';
import { Button } from '@/components/button';
import { Pages2Icon } from '@/components/icons/Pages2Icon';
import type { OfferItem } from '@/types/offers';
import { getBookmakerDetailsUrl } from '@/utils/bookmaker';
import { cn } from '@/utils/cn';

export type OfferCardProps = {
  data: OfferItem;
  isHighlighted?: boolean;
  className?: string;
};

export const OfferCard = ({
  data,
  isHighlighted = false,
  className,
}: OfferCardProps) => {
  const { Label, Code, Url, Image: ImageData, Slug } = data?.attributes || {};

  const imageUrl = ImageData?.data?.attributes?.formats?.thumbnail?.url;
  const bookmakerDetailsUrl = getBookmakerDetailsUrl(Slug);

  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-xl p-4',
        isHighlighted ? 'bg-custom-gradient' : 'bg-medium-gray',
        className
      )}
    >
      <div>
        <div className="relative aspect-video md:hidden">
          <Image
            alt="bookmaker-logo-mobile"
            className="rounded-xl"
            height={241}
            src={imageUrl}
            width={448}
          />
        </div>
        <div className="relative hidden aspect-video md:block">
          <Image
            alt="bookmaker-logo"
            className="rounded-xl"
            fill
            src={imageUrl}
          />
        </div>
      </div>
      <div className="rounded-lg border border-light-blue-o5 bg-light-blue-o15 p-4">
        <p className="font-medium text-base text-white leading-5">
          {/* 20 Free Spins, No Deposit on{" "}
          <span className="text-light-blue underline">Lucky Lady Moon </span>{" "}
          Exclusive Sign Up Bonus from Bitkingz Casino */}
          {Label}
        </p>
      </div>
      <div className="flex flex-col items-center gap-2 rounded-lg border border-light-blue border-dashed px-3 py-4">
        <p className="font-semibold text-light-blue text-xs">{Code}</p>
        <div className="flex flex-row gap-0.5">
          <Pages2Icon
            className="text-blue-gray"
            desc="Copy code icon"
            title="Copy Code"
          />
          <button
            className="cursor-pointer whitespace-nowrap font-normal text-gray text-xs leading-5"
            onClick={() => {
              navigator.clipboard.writeText(Code);
              toast.info('Code coppied', {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'dark',
                transition: Bounce,
              });
            }}
            type="button"
          >
            Click to copy and&nbsp;
            <span className="font-semibold text-light-blue">claim bonus</span>
          </button>
        </div>
      </div>
      <Button as="link" href={Url} size="lg" target="_blank" variant="primary">
        Make a bet
      </Button>
      <Link
        className="p-2 text-center font-semibold text-light-blue text-sm leading-4"
        href={bookmakerDetailsUrl}
      >
        View bookmaker review
      </Link>
    </div>
  );
};
